import { fetchColor } from "../../services/color";
import { action, thunk } from "easy-peasy";

export const colorModel = {
  color: "linear-gradient(90deg, #447f3f 0.44%, #a5daa1 100%);",
  textColor: "#447f3f",
  accordionColor: "#a5daa1",
  iconColor: "#a5daa1",
  error: null,
  setError: action((state, payload) => {
    state.error = payload;
  }),
  setIconColor: action((state, payload) => {
    state.iconColor = payload;
  }),
  setAccordionCOlor: action((state, payload) => {
    state.accordionColor = payload;
  }),
  setColor: action((state, payload) => {
    state.color = payload;
  }),
  setTextColor: action((state, payload) => {
    state.textColor = payload;
  }),
  getColor: thunk(async (actions, payload) => {
    try {
      const request = await fetchColor();
      if (request && !request.error) {
        if (request?.color) actions.setColor(request?.color);
        if (request?.textcolor) actions.setTextColor(request?.textcolor);
        if (request?.accordion) actions.setAccordionCOlor(request?.accordion);
        if (request?.icon) actions.setIconColor(request?.icon);
      }
    } catch (err) {
      actions.setError(err);
    }
  }),
};
